import "@/App.css";
import { useState } from "react";
import Deck from "@/deck/Deck";
import Gate from "@/deck/Gate";

function App() {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem("sl_access") === "1"
  );

  return (
    <div className="App">
      {unlocked ? <Deck /> : <Gate onUnlock={() => setUnlocked(true)} />}
    </div>
  );
}

export default App;
